import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ShopProvider } from "@/contexts/ShopContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Keywords from "@/pages/Keywords";
import SiteAudit from "@/pages/SiteAudit";
import Competitors from "@/pages/Competitors";
import CRO from "@/pages/CRO";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import SearchConsole from "@/pages/SearchConsole";
import DataForSeoHealth from "@/pages/DataForSeoHealth";
import Backlinks from "@/pages/Backlinks";
import AppShell from "@/components/layout/AppShell";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <ShopProvider>
              <AppShell />
            </ShopProvider>
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/keywords" element={<Keywords />} />
        <Route path="/audit" element={<SiteAudit />} />
        <Route path="/competitors" element={<Competitors />} />
        <Route path="/backlinks" element={<Backlinks />} />
        <Route path="/cro" element={<CRO />} />
        <Route path="/search-console" element={<SearchConsole />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/dataforseo-health" element={<DataForSeoHealth />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
